<ng-container *ngIf="wrapper; else defaultContent">
  <ng-container
    *ngTemplateOutlet="
      wrapper;
      context: {
        $implicit: text,
        handleClick: handleClick.bind(this)
      }
    "
  ></ng-container>
</ng-container>

<ng-template #defaultContent>
  <button (click)="handleClick()">
    {{ text }}
  </button>
</ng-template>

<app-shared-modal
  [open]="modalOpen"
  name="Setup Organization"
  (modalClose)="modalOpen = false"
>
  <p class="mb-3">
    Looks like you haven't set up your organization yet. Please complete your
    organization setup to <b>submit deals</b>.
  </p>
  <div class="flex gap-3">
    <app-shared-button (click)="navigateToMyOrganization()">
      Manage Organization
    </app-shared-button>
    <app-shared-button theme="outline" (click)="modalOpen = false">
      Setup Later
    </app-shared-button>
  </div>
</app-shared-modal>
